import { PayloadAction } from '@reduxjs/toolkit';

import { AppState, LoaderType } from 'editor/src/store/app/types';

const removeLoaderReducer = (state: AppState, { payload }: PayloadAction<LoaderType>) => {
  state.activeLoaders[payload] = undefined;
};

export default removeLoaderReducer;
